export enum LiveStatus {
    PRE_EVENT = "PRE_EVENT",
    PREPARING_FOR_LIVE = "PREPARING_FOR_LIVE",
    READY_FOR_LIVE = "READY_FOR_LIVE",
    LIVE_INITIALIZING = "LIVE_INITIALIZING",
    LIVE = "LIVE",
    LIVE_PAUSED = "LIVE_PAUSED",
    POST_EVENT = "POST_EVENT",
}
